import React from 'react';
import ImageGallery from 'react-image-gallery';

const ItemTile = ({item}) => {

    return <a href={`/sales/inventory/items/${item.id}`} className='itemTile'>
        <h2>{item.name}</h2>
        <div className='imageContainer'>
            <img src={`https://naawebsitestorage.blob.core.windows.net/images/${item.id}/${item.id}_thumb.jpg`} alt={`${item.name} for sale`} width={400} height={300}></img>
        </div>
        <div className='tileBottom'>
            <p className='hotBuy'>{item.hotBuy && "Hot Buy!"}</p>
            <p className='price'>{`$${item.price}`}</p>
        </div>
        
    </a>
}

export default ItemTile;